import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  disconnect() {
    if (this.isConfirmed) return;

    this.dispatch("unconfirm");
  }

  confirm() {
    this.dispatch("confirm");
    this.isConfirmed = true;
    this.element.close();
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }
}
